import {
    getStateFromElement,
    setState,
} from '@js/utilities/bootstrap-modules-controller/bootstrapModulesHelpers';

export const collapseListener = (collapseElements) => {
    if (!collapseElements?.length) {
        return;
    }

    collapseElements.forEach((el) => {
        const bootstrapModuleElement = document.querySelector(el.dataset.bsTarget);

        if (bootstrapModuleElement && !bootstrapModuleElement?.dataset.bootstrapModuleInitialized) {
            const elementData = getStateFromElement(el);

            bootstrapModuleElement.addEventListener(`shown.bs.${elementData.toggle}`, () => {
                setState(elementData.target, {
                    ...elementData,
                    active: true,
                });
            });

            bootstrapModuleElement.addEventListener(`hidden.bs.${elementData.toggle}`, () => {
                setState(elementData.target, {
                    ...elementData,
                    active: false,
                });
            });
        }
    });
};

const activateCollapseModule = (DOM, element, data) => {
    if (data.active) {
        if (element.dataset.bsParent) {
            const elementsToDisactivate = DOM.querySelectorAll(
                `[data-bs-parent="${element.dataset.bsParent}"]`
            );

            elementsToDisactivate.forEach((el) => {
                el.classList.remove('show');
            });
        }

        element.classList.add('show');
    } else {
        element.classList.remove('show');
    }
};

export const collapseActivator = (DOM, state) => {
    Object.keys(state).forEach((toggle) => {
        DOM.querySelectorAll(toggle).forEach((el) => {
            activateCollapseModule(DOM, el, state[toggle]);
        });
    });

    return DOM;
};
